import styled from 'styled-components';

export const SetupModeCardGroup = styled.div`
    display: flex;
    gap: ${({ theme }) => theme.spacing(2)};
    width: 100%;
`;

export const SetupModeCard = styled.div<{ $selected: boolean; $disabled?: boolean }>`
    flex: 1;
    display: grid;
    grid-template-columns: auto 1fr;
    column-gap: ${({ theme }) => theme.spacing(1)};
    row-gap: ${({ theme }) => theme.spacing(0.5)};
    padding: ${({ theme }) => `${theme.spacing(2)} ${theme.spacing(2)}`};
    cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
    opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};
    border-radius: ${({ theme }) => theme.spacing(0.5)};
    border: ${({ theme, $selected }) => `1px solid ${$selected ? theme.tokens.BaseColorBlue700 : theme.tokens.BaseColorGray300}`};
    background-color: ${({ theme, $selected }) => ($selected ? theme.tokens.BaseColorBlue50 : 'transparent')};
`;

// Hand-drawn: RadioButtonList options carry no description.
export const SetupModeRadio = styled.span<{ $selected: boolean }>`
    margin-top: ${({ theme }) => theme.spacing(0.25)};
    width: 16px;
    height: 16px;
    border-radius: 50%;
    border: ${({ theme, $selected }) => `1px solid ${$selected ? theme.tokens.BaseColorBlue700 : theme.tokens.BaseColorGray600}`};
    display: inline-flex;
    align-items: center;
    justify-content: center;

    &::after {
        content: '';
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: ${({ theme, $selected }) => ($selected ? theme.tokens.BaseColorBlue700 : 'transparent')};
    }
`;

// Spans both grid columns so the description sits flush with the radio, not indented under the title.
export const SetupModeDescription = styled.div`
    grid-column: 1 / -1;
`;

const CONTROL_HEIGHT = '40px';

export const StockNumberRow = styled.div`
    display: flex;
    align-items: flex-end;
    gap: ${({ theme }) => theme.spacing(2)};
    width: 100%;
`;

export const StockNumberField = styled.div`
    flex: 1;
    min-width: 0;
`;

// Shares the field's control line so OR and the button align with the value above.
export const StockNumberActions = styled.div`
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.spacing(2)};
    height: ${CONTROL_HEIGHT};

    button {
        height: ${CONTROL_HEIGHT};
    }
`;

export const TemplateSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing(1)};
    width: 100%;
`;

export const ReadOnlyField = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing(0.5)};
    min-height: ${CONTROL_HEIGHT};
    justify-content: flex-end;
`;
